var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9599 19.8333H7.29326C7.06214 19.8303 6.84133 19.7372 6.67789 19.5737C6.51444 19.4103 6.42129 19.1895 6.41826 18.9583V9.91667L0.176598 1.38833C0.0779465 1.26008 0.0178726 1.10637 0.00340951 0.945211C-0.0110536 0.784051 0.0206924 0.622105 0.0949314 0.478333C0.169305 0.334975 0.281421 0.214652 0.419177 0.130353C0.556934 0.0460541 0.715098 0.000981401 0.876598 0H18.3766C18.5381 0.000981401 18.6963 0.0460541 18.834 0.130353C18.9718 0.214652 19.0839 0.334975 19.1583 0.478333C19.2325 0.622105 19.2642 0.784051 19.2498 0.945211C19.2353 1.10637 19.1752 1.26008 19.0766 1.38833L12.8349 9.91667V18.9583C12.8319 19.1895 12.7388 19.4103 12.5753 19.5737C12.4119 19.7372 12.1911 19.8303 11.9599 19.8333ZM8.16826 18.0833H11.0849V9.625C11.0831 9.43895 11.1448 9.25785 11.2599 9.11167L16.6266 1.75H2.6266L8.0166 9.11167C8.1317 9.25785 8.19344 9.43895 8.1916 9.625L8.16826 18.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterEmpty);
export default __webpack_public_path__ + "static/media/filter_empty.9614d5cd772f509f73947974289d6cfb.svg";
export { ForwardRef as ReactComponent };